module.exports = __webpack_public_path__ + "static/media/user.f27384a9.png";